var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgResults = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_27_8",
    "data-name": "Component 27 \\u2013 8",
    width: 393.998,
    height: 391.057,
    viewBox: "0 0 393.998 391.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    d: "M10,0H224a10,10,0,0,1,10,10V200A100,100,0,0,1,134,300H100A100,100,0,0,1,0,200V10A10,10,0,0,1,10,0Z",
    transform: "translate(79.998)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M17579.371-13387a5.378,5.378,0,0,1-5.369-5.374V-13410h.006a40.749,40.749,0,0,0,15.953-3.221,40.862,40.862,0,0,0,13.031-8.786,40.877,40.877,0,0,0,8.785-13.03A40.751,40.751,0,0,0,17615-13451v-45.229a14.67,14.67,0,0,0-4.326-10.445,14.671,14.671,0,0,0-10.445-4.327H17574l0-16.627a5.378,5.378,0,0,1,5.369-5.374h38.143a21.353,21.353,0,0,1,8.361,1.688,21.389,21.389,0,0,1,6.83,4.6,21.4,21.4,0,0,1,4.605,6.83,21.319,21.319,0,0,1,1.689,8.364v64.884a59.241,59.241,0,0,1-4.687,23.209,59.457,59.457,0,0,1-5.5,10.13,60.05,60.05,0,0,1-7.279,8.825,60.122,60.122,0,0,1-8.826,7.281,59.623,59.623,0,0,1-10.129,5.5A59.226,59.226,0,0,1,17579.371-13387Z",
    transform: "translate(-17245.002 13581)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    d: "M7,0H40a0,0,0,0,1,0,0V62a0,0,0,0,1,0,0H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0Z",
    transform: "translate(227.998 314.5) rotate(90)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    d: "M7,0H21.057a20,20,0,0,1,20,20V173a20,20,0,0,1-20,20H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0Z",
    transform: "translate(100.498 391.057) rotate(-90)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M17633.631-13387a59.249,59.249,0,0,1-23.211-4.687,59.623,59.623,0,0,1-10.129-5.5,59.986,59.986,0,0,1-8.824-7.281,59.983,59.983,0,0,1-7.281-8.825,59.684,59.684,0,0,1-5.5-10.13,59.253,59.253,0,0,1-4.686-23.209v-64.884a21.319,21.319,0,0,1,1.689-8.364,21.4,21.4,0,0,1,4.6-6.83,21.422,21.422,0,0,1,6.83-4.6,21.372,21.372,0,0,1,8.365-1.688h38.141a5.378,5.378,0,0,1,5.369,5.374V-13511h-26.223a14.685,14.685,0,0,0-10.451,4.327,14.67,14.67,0,0,0-4.326,10.445V-13451a40.751,40.751,0,0,0,3.221,15.958,40.871,40.871,0,0,0,8.787,13.03,40.819,40.819,0,0,0,13.031,8.786A40.756,40.756,0,0,0,17639-13410v17.628A5.378,5.378,0,0,1,17633.631-13387Z",
    transform: "translate(-17574.002 13581)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResults, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/results.827e1a4d.svg";
export { ForwardRef as ReactComponent };